import type { CollectionConfig } from "../core/types";
import { genesis002Collection } from "./genesis002/config";

const collections: Readonly<Record<string, CollectionConfig>> = {
  [genesis002Collection.publicId]: genesis002Collection,
};

export function getCollectionConfig(collectionId: string): CollectionConfig {
  const collection = collections[collectionId];
  if (!collection) throw new Error(`Unsupported Kowry collection: ${collectionId}`);
  return collection;
}

export { genesis002Collection };